import { useParams } from "react-router-dom";
import { ProductForm } from "./productform";

export const EditProduct = () => {
  const { id } = useParams();
  return <ProductForm mode="edit" id={id} />;
};
